import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import LocalEmbed from 'components/LocalEmbed'
import styles from './Embed.css'
import { useProfileContext } from 'lib-core'

if (typeof window !== 'undefined') {
  let init_embedly = function (w, d) {
    var id = 'embedly-platform',
      n = 'script'
    if (!d.getElementById(id)) {
      w.embedly =
        w.embedly ||
        function () {
          ; (w.embedly.q = w.embedly.q || []).push(arguments)
        }
      var e = d.createElement(n)
      e.id = id
      e.async = 1
      e.src =
        ('https:' === document.location.protocol ? 'https' : 'http') +
        '://cdn.embedly.com/widgets/platform.js'
      var s = d.getElementsByTagName(n)[0]
      if (s && s.parentNode) s.parentNode.insertBefore(e, s)
    }
  }
  init_embedly(window, document)
}

class EmbedlyEmbed extends Component {
  constructor(props) {
    super(props)
    this.embed = this.embed.bind(this)
  }
  embed(el) {
    if (el) {
      embedly('card', el)
    }
  }
  render() {
    let { data: { url, description }, embedlyKey } = this.props
    let css = `.embedly-card:last-child .embedly-card-hug {
        padding: 1em !important;
        border:0.01em solid #ddd;
      }`
    return (
      <div>
        <style>{css}</style>
        <div>
          <a
            data-card-key={embedlyKey}
            data-card-controls="0"
            data-card-recommend="0"
            data-card-width="100%"
            ref={this.embed}
            href={url}
          >
            <span className={styles.embed_loading}>
              <FormattedMessage id="embed.loading" />
            </span>
          </a>
        </div>
      </div>
    )
  }
}

const isUrl = str => str && str.toLowerCase().startsWith('http')

const Embed = props => {
  const { instance } = useProfileContext()
  const embedlyKey = instance && instance.embedlyKey
  let { data: { url, } } = props
  if (isUrl(url)) {
    return <EmbedlyEmbed  embedlyKey= {embedlyKey} {...props} />
  } else {
    return <LocalEmbed  embedlyKey= {embedlyKey} {...props} />
  }
}

// const mapStateToProps = (
//   { instance }
// ) => {
//   return {
//     embedlyKey: instance?.value?.embedlyKey
//   }
// }

export default Embed
